export const formId = 'ReportForm';

export default {
  streetName: '',
  houseNumber: '',
  postcode: '',
  location: '',
  subject0: '',
  subject1: '',
  subject2: '',
  subject3: '',
  description: '',
  fullName: '',
  emailAddress: '',
  phoneNumber: '',
  termsConditions: false,
  images: [],
};
